export const prefixkey = 'popup_close_time_';
// 新增：基于设备ID的每日访问记录前缀
export const deviceDailyVisitPrefix = 'device_daily_visit_';

function timeDiff(prevTime: number, afterTime: number, hour: number) {
    const timeDiff = Math.abs(afterTime - prevTime);
    const hoursDiff = timeDiff / (1000 * 60 * 60);

    if (hoursDiff > hour) {
        return true;
    }

    return false;
}

// 检查是否为当天首次访问（基于设备ID）
export function checkIsFirstVisitToday(deviceId: string, pageKey: string) {
    if (!deviceId) return false;

    const today = new Date().toDateString(); // 获取今天的日期字符串
    const key = `${deviceDailyVisitPrefix}${deviceId}_${pageKey}`;
    const lastVisitDate = localStorage.getItem(key);
    return lastVisitDate !== today;
}

// 记录今日访问（基于设备ID）
export function recordTodayVisit(deviceId: string, pageKey: string) {
    if (!deviceId) return;

    const today = new Date().toDateString();
    const key = `${deviceDailyVisitPrefix}${deviceId}_${pageKey}`;
    localStorage.setItem(key, today);
}

// 理过期的设备访问记录
export function clearExpiredDeviceRecords() {
    const keys = Object.keys(localStorage);
    const today = new Date().toDateString();

    const expiredKeys = keys
        .filter((key) => key.startsWith(deviceDailyVisitPrefix))
        .filter((key) => {
            const value = localStorage.getItem(key);
            return value && value !== today;
        });

    expiredKeys.forEach((key) => {
        localStorage.removeItem(key);
    });
}

export function clearExpiredRecord() {
    const keys = Object.keys(localStorage);
    const recordValues = keys
        .filter((key) => key.startsWith(prefixkey))
        .map((key) => {
            const k = localStorage.getItem(key);
            if (k) {
                const timeNumber = parseInt(k, 10);
                const currentTime = Date.now();

                if (timeDiff(currentTime, timeNumber, 24)) {
                    return key;
                }

                return '';
            }
        })
        .filter((key) => !!key);

    recordValues.forEach((item) => {
        item && localStorage.removeItem(item);
    });

    // 同时清理过期的设备访问记录
    clearExpiredDeviceRecords();
}

export function recordTime(locale: string) {
    const currentTime = Date.now();
    locale && window.localStorage.setItem(`${prefixkey}${locale}`, currentTime.toString());
}

export function checkIsWithinTime(locale: string) {
    const key = `${prefixkey}${locale}`;
    const value = localStorage.getItem(key);
    if (!value) return false;

    const timeNumber = parseInt(value, 10);
    const currentTime = Date.now();

    return !timeDiff(currentTime, timeNumber, 24);
}
